import { sk } from '@formkit/i18n'
import { defaultConfig } from '@formkit/vue'
import { genesisIcons } from '@formkit/icons'
import { createProPlugin, inputs } from '@formkit/pro'
import { rootClasses } from './formkit.theme'

const pro = createProPlugin('fk-33802a2588', inputs)

export default defaultConfig({
  locales: { sk },
  locale: 'sk',
  icons: {
    ...genesisIcons
  },
  plugins: [pro],
  config: {
    rootClasses,
  },
})